import helpers from "../helpers";

export default class ColorHueService {
    constructor(hue, saturation, light) {
        this.minHue = 0;
        this.maxHue = 360;

        this.maxLight = 80;

        this.scaleLight = 15;

        this.hue = (hue || helpers.randomNum(this.minHue, this.maxHue));
        // Redo if ugly hue is generated, because magenta is hideous
        if (this.hue > 288 && this.hue < 316) {
            this.hue = helpers.randomNum(316, 360);
        } else if (this.hue > 280 && this.hue < 288) {
            this.hue = helpers.randomNum(260, 280);
        }

        this.saturation = saturation;
        this.light = light;
        this.hsl = 'hsl(' + this.hue + ', ' + this.saturation + '%, ' + this.light + '%)';
    }

    getHSL() {
        return 'hsl(' + this.getHue() + ', ' + this.getSaturation() + '%, ' + this.getLight() + '%)';
    }

    getSaturation() {
        if(typeof this.saturation === 'undefined') {
            this.saturation = helpers.randomNum(75, 100);
        }
        return this.saturation;
    }
    changeHue(hue, rotate) {
        return hue + rotate > this.maxHue ?
            (hue + rotate) - this.maxHue : hue + rotate;
    }
    getLight(light) {
        if(typeof light === 'undefined') {
            this.light = helpers.randomNum(65, 80);
            return this.light;
        }
        return light + this.scaleLight > this.maxLight ? this.maxLight : light + this.scaleLight;
    }
    getHue() {
        if(typeof this.hue === 'undefined') {
            this.hue = helpers.randomNum(0, 360);
        }
        return this.hue;
    }


}
